/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Twittersite1Inputs */

const ja_metadata_twittersite1 = /** @type {(inputs: Metadata_Twittersite1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`@playbrain_ja`)
};

const en_metadata_twittersite1 = /** @type {(inputs: Metadata_Twittersite1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`@playbrain_en`)
};

/**
* | output |
* | --- |
* | "@playbrain_en" |
*
* @param {Metadata_Twittersite1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const metadata_twittersite1 = /** @type {((inputs?: Metadata_Twittersite1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Twittersite1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_metadata_twittersite1(inputs)
	return en_metadata_twittersite1(inputs)
});
export { metadata_twittersite1 as "metadata_twitterSite" }